<div class="generating-container" *ngIf="isGenerating; else resultTemplate">
  <div class="generating-card">
    <div class="init-loading__morph-container" aria-hidden="true">
      <div class="init-loading__shape"></div>
      <div class="init-loading__shape"></div>
      <div class="init-loading__shape"></div>
    </div>
    <div class="generating-text">
      Generating field mapping<span class="init-loading__dots" aria-hidden="true"><span class="init-loading__dot">.</span><span class="init-loading__dot">.</span><span class="init-loading__dot">.</span></span>
    </div>
    <div class="generating-subtext">This may take up to 3 minutes</div>
  </div>
</div>

<ng-template #resultTemplate>
  <div class="result-container" *ngIf="error">
    <div class="error-card">
      <mat-icon class="error-icon">error_outline</mat-icon>
      <span class="error-text">{{ error }}</span>
      <button class="retry-btn" (click)="generate()">Retry</button>
    </div>
  </div>
</ng-template>
